import { render, staticRenderFns } from "./cardDetaile.vue?vue&type=template&id=3a9aadf3&scoped=true"
import script from "./cardDetaile.vue?vue&type=script&lang=js"
export * from "./cardDetaile.vue?vue&type=script&lang=js"
import style0 from "./cardDetaile.vue?vue&type=style&index=0&id=3a9aadf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9aadf3",
  null
  
)

export default component.exports